/**
 * @aurora-catalyst-generated
 * @source cliter/iam/account.aurora.yaml
 */
import { type TypedDocumentNode } from '@apollo/client/core';
import {
  type IamAccountFieldsFragment,
  type IamActivateTwoFactorMeAccountMutation,
  type IamActivateTwoFactorMeAccountMutationVariables,
  type IamAddMeMetaItemsMutation,
  type IamAddMeMetaItemsMutationVariables,
  type IamChangePasswordMeAccountMutation,
  type IamChangePasswordMeAccountMutationVariables,
  type IamCheckUniqueEmailAccountQuery,
  type IamCheckUniqueEmailAccountQueryVariables,
  type IamCheckUniqueUsernameAccountQuery,
  type IamCheckUniqueUsernameAccountQueryVariables,
  type IamCreateAccountMutation,
  type IamCreateAccountMutationVariables,
  type IamDeleteAccountByIdMutation,
  type IamDeleteAccountByIdMutationVariables,
  type IamDisableTwoFactorMeAccountMutation,
  type IamDisableTwoFactorMeAccountMutationVariables,
  type IamEnrollTwoFactorMeAccountMutation,
  type IamEnrollTwoFactorMeAccountMutationVariables,
  type IamFindAccountByIdQuery,
  type IamFindAccountByIdQueryVariables,
  type IamGetAccountsQuery,
  type IamGetAccountsQueryVariables,
  type IamMeAccountQuery,
  type IamMeAccountQueryVariables,
  type IamMeAvatarAccountQuery,
  type IamMeAvatarAccountQueryVariables,
  type IamMeTwoFactorAccountQuery,
  type IamMeTwoFactorAccountQueryVariables,
  type IamPaginateAccountsQuery,
  type IamPaginateAccountsQueryVariables,
  type IamRegenerateTwoFactorRecoveryCodesMeAccountMutation,
  type IamRegenerateTwoFactorRecoveryCodesMeAccountMutationVariables,
  type IamRemoveMeMetaItemsMutation,
  type IamRemoveMeMetaItemsMutationVariables,
  type IamResetTwoFactorAccountMutation,
  type IamResetTwoFactorAccountMutationVariables,
  type IamUpdateAccountByIdMutation,
  type IamUpdateAccountByIdMutationVariables,
  type IamUpdateMeAccountMutation,
  type IamUpdateMeAccountMutationVariables,
} from '@src/src/app/aurora.types';
import gql from 'graphql-tag';

export const iamAccountFields: TypedDocumentNode<IamAccountFieldsFragment, unknown> = gql`
  fragment IamAccountFields on IamAccount {
    rowId
    type
    code
    email
    username
    isActive
    clientId
    client {
      id
      rowId
      grantType
      scopeOptions
      name
      isMaster
      authUrl
      redirect
      accessTokenLifetimeSeconds
      refreshTokenLifetimeSeconds
      isActive
    }
    tags
    scopes
    dApplicationCodes
    dPermissions
    dTenants
    hasAddChildTenants
    meta
    roles {
      id
      rowId
      name
      code
      defaultRedirection
      hasHiddenVerticalNavigation
      isMaster
    }
    tenants {
      id
      rowId
      name
      code
      logo
      isActive
      meta
      managedBy
    }
    user {
      id
      rowId
      name
      surname
      mobile
      langId
      isTwoFactorAuthenticationEnabled
      twoFactorAuthenticationLastUsedStep
      twoFactorAuthenticationFailedAttempts
      twoFactorAuthenticationLockedUntil
      twoFactorAuthenticationChallengeExpiresAt
      meta
    }
    managedBy
    createdAt
    updatedAt
  }
`;

// default methods
export const paginationQuery: TypedDocumentNode<
  IamPaginateAccountsQuery,
  IamPaginateAccountsQueryVariables
> = gql`
  query IamPaginateAccounts($query: QueryStatementInput, $constraint: QueryStatementInput) {
    pagination: iamPaginateAccounts(query: $query, constraint: $constraint) {
      total
      rows
      count
    }
  }
`;

export const getQuery: TypedDocumentNode<IamGetAccountsQuery, IamGetAccountsQueryVariables> = gql`
  query IamGetAccounts($query: QueryStatementInput, $constraint: QueryStatementInput) {
    objects: iamGetAccounts(query: $query, constraint: $constraint) {
      id
      ...IamAccountFields
    }
  }
  ${iamAccountFields}
`;

export const findByIdQuery: TypedDocumentNode<
  IamFindAccountByIdQuery,
  IamFindAccountByIdQueryVariables
> = gql`
  query IamFindAccountById($id: ID, $constraint: QueryStatementInput) {
    object: iamFindAccountById(id: $id, constraint: $constraint) {
      id
      ...IamAccountFields
    }
  }
  ${iamAccountFields}
`;

export const createMutation: TypedDocumentNode<
  IamCreateAccountMutation,
  IamCreateAccountMutationVariables
> = gql`
  mutation IamCreateAccount($payload: IamCreateAccountInput!) {
    iamCreateAccount(payload: $payload) {
      ...IamAccountFields
    }
  }
  ${iamAccountFields}
`;

export const updateByIdMutation: TypedDocumentNode<
  IamUpdateAccountByIdMutation,
  IamUpdateAccountByIdMutationVariables
> = gql`
  mutation IamUpdateAccountById(
    $payload: IamUpdateAccountByIdInput!
    $constraint: QueryStatementInput
  ) {
    iamUpdateAccountById(payload: $payload, constraint: $constraint) {
      ...IamAccountFields
    }
  }
  ${iamAccountFields}
`;

export const deleteByIdMutation: TypedDocumentNode<
  IamDeleteAccountByIdMutation,
  IamDeleteAccountByIdMutationVariables
> = gql`
  mutation IamDeleteAccountById($id: ID!, $constraint: QueryStatementInput) {
    iamDeleteAccountById(id: $id, constraint: $constraint) {
      ...IamAccountFields
    }
  }
  ${iamAccountFields}
`;

// Queries additionalApis
export const meAccountQuery: TypedDocumentNode<IamMeAccountQuery, IamMeAccountQueryVariables> = gql`
  query IamMeAccount {
    iamMeAccount {
      id
      email
      username
      dPermissions
      user {
        id
        name
        surname
        mobile
        langId
        meta
      }
      roles {
        id
        defaultRedirection
        hasHiddenVerticalNavigation
      }
    }
    iamMeAvatarAccount
  }
`;

/**
 * Adds items to a catalogued owner-writable list of the user's `meta` and returns the list now
 * stored under `key`.
 */
export const addMeMetaItemsMutation: TypedDocumentNode<
  IamAddMeMetaItemsMutation,
  IamAddMeMetaItemsMutationVariables
> = gql`
  mutation IamAddMeMetaItems($payload: IamMeMetaItemsInput!) {
    iamAddMeMetaItems(payload: $payload)
  }
`;
/** Removes items from the list; returns the list now stored under `key`. */
export const removeMeMetaItemsMutation: TypedDocumentNode<
  IamRemoveMeMetaItemsMutation,
  IamRemoveMeMetaItemsMutationVariables
> = gql`
  mutation IamRemoveMeMetaItems($payload: IamMeMetaItemsInput!) {
    iamRemoveMeMetaItems(payload: $payload)
  }
`;
export const meAvatarAccountQuery: TypedDocumentNode<
  IamMeAvatarAccountQuery,
  IamMeAvatarAccountQueryVariables
> = gql`
  query IamMeAvatarAccount {
    iamMeAvatarAccount
  }
`;
export const checkUniqueUsernameAccountQuery: TypedDocumentNode<
  IamCheckUniqueUsernameAccountQuery,
  IamCheckUniqueUsernameAccountQueryVariables
> = gql`
  query IamCheckUniqueUsernameAccount($username: String!, $avoidUsernames: [String!]) {
    iamCheckUniqueUsernameAccount(username: $username, avoidUsernames: $avoidUsernames)
  }
`;
export const checkUniqueEmailAccountQuery: TypedDocumentNode<
  IamCheckUniqueEmailAccountQuery,
  IamCheckUniqueEmailAccountQueryVariables
> = gql`
  query IamCheckUniqueEmailAccount($email: String!, $avoidEmails: [String!]) {
    iamCheckUniqueEmailAccount(email: $email, avoidEmails: $avoidEmails)
  }
`;
// Mutation additionalApis
export const updateMeAccountMutation: TypedDocumentNode<
  IamUpdateMeAccountMutation,
  IamUpdateMeAccountMutationVariables
> = gql`
  mutation IamUpdateMeAccount($payload: IamUpdateMeAccountInput!) {
    iamUpdateMeAccount(payload: $payload) {
      id
      email
      username
      user {
        id
        name
        surname
        mobile
        langId
      }
    }
  }
`;
export const changePasswordMeAccountMutation: TypedDocumentNode<
  IamChangePasswordMeAccountMutation,
  IamChangePasswordMeAccountMutationVariables
> = gql`
  mutation IamChangePasswordMeAccount($currentPassword: String!, $newPassword: String!) {
    iamChangePasswordMeAccount(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;
export const meTwoFactorAccountQuery: TypedDocumentNode<
  IamMeTwoFactorAccountQuery,
  IamMeTwoFactorAccountQueryVariables
> = gql`
  query IamMeTwoFactorAccount {
    iamMeTwoFactorAccount {
      isAvailable
      isRequired
      isEnabled
      remainingRecoveryCodes
    }
  }
`;
export const enrollTwoFactorMeAccountMutation: TypedDocumentNode<
  IamEnrollTwoFactorMeAccountMutation,
  IamEnrollTwoFactorMeAccountMutationVariables
> = gql`
  mutation IamEnrollTwoFactorMeAccount {
    iamEnrollTwoFactorMeAccount {
      otpauthUri
      secret
    }
  }
`;
export const activateTwoFactorMeAccountMutation: TypedDocumentNode<
  IamActivateTwoFactorMeAccountMutation,
  IamActivateTwoFactorMeAccountMutationVariables
> = gql`
  mutation IamActivateTwoFactorMeAccount($code: String!) {
    iamActivateTwoFactorMeAccount(code: $code) {
      recoveryCodes
    }
  }
`;
export const disableTwoFactorMeAccountMutation: TypedDocumentNode<
  IamDisableTwoFactorMeAccountMutation,
  IamDisableTwoFactorMeAccountMutationVariables
> = gql`
  mutation IamDisableTwoFactorMeAccount($code: String, $recoveryCode: String) {
    iamDisableTwoFactorMeAccount(code: $code, recoveryCode: $recoveryCode)
  }
`;
export const regenerateTwoFactorRecoveryCodesMeAccountMutation: TypedDocumentNode<
  IamRegenerateTwoFactorRecoveryCodesMeAccountMutation,
  IamRegenerateTwoFactorRecoveryCodesMeAccountMutationVariables
> = gql`
  mutation IamRegenerateTwoFactorRecoveryCodesMeAccount($code: String!) {
    iamRegenerateTwoFactorRecoveryCodesMeAccount(code: $code) {
      recoveryCodes
    }
  }
`;
export const resetTwoFactorAccountMutation: TypedDocumentNode<
  IamResetTwoFactorAccountMutation,
  IamResetTwoFactorAccountMutationVariables
> = gql`
  mutation IamResetTwoFactorAccount($id: ID!) {
    iamResetTwoFactorAccount(id: $id)
  }
`;
